import geoCalcMixin from 'src/mixins/geoCalcMixin'
import geoApi from 'src/apis/geo'

export default {
  mixins: [geoCalcMixin],
  methods: {
    async getJointByGeoInfo(lat, lon, geoLocStr = null) {
      if ((!lat || !lon) && !geoLocStr) { return }

      if (geoLocStr) {
        const locations = []
        const chunkSize = 2
        const geoLocations = geoLocStr.split(',')
        for (let i = 0; i < geoLocations.length; i += chunkSize) {
          const [lat, lon] = geoLocations.slice(i, i + chunkSize)
          locations.push({ lat: lat, lon: lon })
        }
        return await this.getJointByLocations(locations, lat, lon)
      } else {
        return await this.getJointByLocation(lat, lon)
      }
    },
    async getJointByLocation(lat, lon) {
      const { data: { joints } } = await geoApi.getJoints(lat, lon)
      const joint = joints.slice().sort((a, b) => {
        const val1 = parseFloat(a.dist)
        const val2 = parseFloat(b.dist)
        return val1 - val2
      })[0]
      return joint
    },
    async getJointByLocations(locations, lat, lon) {
      const { data: { joints } } = await geoApi.getJointsByLocations(locations)
      const loc = locations[0]
      const joint = await this.getClosestJoint(joints, lat, lon, loc.lat, loc.lon)
      return joint
    },
    async getClosestJoint(joints, lat1, lon1, lat2, lon2) {
      // イベント発生位置情報
      const pt1 = { lat: parseFloat(lat1), lon: parseFloat(lon1) }
      // 一番先頭の位置情報(取得するジョイントまでの距離の基準位置)
      const pt2 = { lat: parseFloat(lat2), lon: parseFloat(lon2) }

      // イベント発生位置から一番先頭の位置情報の距離を計算（＝間隔）
      const dist = this.getDistance(pt1, pt2)
      const maxDist = 50
      let joint = joints[0]
      for (const j of joints) {
        // 同一ジョイント番号は無視
        if (j.joint_number === joint.joint_number) { continue }

        // 取得したジョイントまでの距離から間隔を差し引いて、上限値を超えたら処理をやめる
        // (以降、どんどん距離が離れるだけだから)
        if (parseFloat(j.dist) - dist >= maxDist) { break }

        // イベント発生位置からジョイントまでの距離を取得
        const { data: { distance } } = await geoApi.getJointDistance(j.id, lat1, lon1)
        // 距離が近くなるなら処理続行
        // 遠くなり始めたら処理をやめる(以降、どんどん距離が離れるだけだから)
        if (parseFloat(joint.dist) <= parseFloat(distance)) { break }

        joint = j
      }
      return joint
    },
  }
}
